import { render, staticRenderFns } from "./make-send-dialog.vue?vue&type=template&id=002e9b2a&scoped=true&"
import script from "./make-send-dialog.vue?vue&type=script&lang=js&"
export * from "./make-send-dialog.vue?vue&type=script&lang=js&"
import style0 from "./make-send-dialog.vue?vue&type=style&index=0&id=002e9b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002e9b2a",
  null
  
)

export default component.exports